/* eslint-disable */
import {
  Sprite, Matrix, Container, Point, Graphics, TextureCache, Texture, Loader, Rectangle,
} from 'pixi.js';


class MapClip extends Container {
  constructor(control) {
    super();
    this.control = control;
    this.width = 800;
    this.height = 600;
    this.typeName = 'MapClip';
  }

  async initMap(mapData) {
    this.mapData = mapData;

    this.mousedata = {
      down: false, moveing: false, d_x: null, d_y: null, over: false,
    };


    console.log('初始化成功：initMap ', this.mapData.id, this.x, this.y, this.mapData.anchor);
    // this.addChild(new Graphics()
    // .beginFill(0xff0000,0.8)
    // .drawRect(0,0,200,200)
    // .endFill());

    // return;

    // const loader = new Loader();

    // const sprites = {};

    // loader.add(this.mapData.vr_id, this.mapData.plymap);

    // loader.load((loader, resources) => {

    //     this.sprite = new Sprite(resources[this.mapData.vr_id].texture);
    //     this.initSprite();
    // });
    const texture = await Texture.fromURL(this.mapData.plymap.replace("https://vrapi", "https://robot-vr"), {
      resourceOptions: { crossorigin: "use-credentials" }
    });
    this.sprite = new Sprite(texture);
    this.initSprite();
  }


  initSprite() {
    this.alpha = 0;

    if (this.mapData.anchor != null) { this.drawMask(); }

    // this.sprite.width = 800;
    // this.sprite.height = 600;

    this.orgwidth = this.sprite.width;
    this.orgheight = this.sprite.height;


    this.sprite.width = 800;
    this.sprite.height = this.sprite.height * this.sprite.width / this.orgwidth;


    this.addChild(this.sprite);

    // this.sprite.x = Math.random()*400;


    setTimeout(() => {
      this.drawBoundBox();
    }, 500);


    this.interactive = this.mapData.canSelect !== false;

    this.on('click', (event) => {
      if (this.mapData.canSelect === false) { return; }
      if (this.control.keyPress.downCode != 0) { return; }
      this.onSelected(true);
    });

    this.on('mousedown', (event) => {
      if (this.mapData.canSelect === false) {
        return;
      }
      if (this.control.keyPress.downCode != 0) { return; }

      event.stopPropagation();
      this.mousedata.down = true;
      this.mousedata.d_x = event.data.global.x;
      this.mousedata.d_y = event.data.global.y;
      this.onSelected(true);
    });

    this.on('mouseup', (event) => {
      // console.log(event.currentTarget.mapData.id);
      // if(this.mapData.id!=event.currentTarget.mapData.id)
      // event.reset();

      if (this.mousedata.down) {
        this.mousedata.down = false;
        // console.log(this.mousedata.down);
        this.mousedata.moveing = false;
        this.SaveData();
        if (this.control.mapClipVisible) {
          if (this.mouseTimer) {
            clearTimeout(this.mouseTimer)
            this.mouseTimer = null
          }
          this.mouseTimer = setTimeout(() => {
            this.control.list.forEach(e => {
              if (!e.selected) {
                e.mapClip.visible = true
              }
            })
          }, 500)
        }
      }
    });

    this.on('mouseover', (event) => {
      this.mousedata.over = true;
    });

    this.on('mouseupoutside', (event) => {
      this.mousedata.over = false;
      this.mousedata.moveing = false;
      this.mousedata.down = false;
    });
    this.on('mousemove', (event) => {
      if (this.mousedata.down) {
        // console.log('元素移动', this)

        this.mousedata.moveing = true;
        // console.log(this.mousedata.down);

        const dx = event.data.global.x - this.mousedata.d_x;
        const dy = event.data.global.y - this.mousedata.d_y;
        this.x += dx / this.control.mapCavans.transform.localTransform.a;
        this.y += dy / this.control.mapCavans.transform.localTransform.a;

        this.mousedata.d_x = event.data.global.x;
        this.mousedata.d_y = event.data.global.y;

        this.control.showSeleted(this);
        if (this.control.mapClipVisible) {
          this.control.list.forEach(e => {
            if (!e.selected) {
              e.mapClip.visible = false
            }
          })
        }
      }
    });

    // document.addEventListener('mousewheel',(e)=>
    // {
    //     if(this.control.keyPress.downCode!=0)
    //     return;
    //     if(!this.boundBox.visible||this.control.editPlaneVisible)return;
    //     if (e.wheelDelta > 0 && this.mousedata.over)
    //     {
    //         this.scale.set(this.scale.x*1.1,this.scale.y*1.1)

    //     }
    //     if (e.wheelDelta < 0&&this.scale.x>0.1)
    //     {
    //         this.scale.set(this.scale.x*0.9,this.scale.y*0.9)

    //     }

    //     this.SaveData();
    // },false);
  }


  releaseSelected() {
    this.mousedata.down = false;
  }


  changedScale(value, anchorPx, anchorPy) {
    const local = this.toLocal(new Point(anchorPx, anchorPy), this.parent);

    // let temppiovt = this.pivot.clone();
    // this.pivot.set(local.x,local.y);

    const n_local = new Point();
    this.transform.localTransform.apply(this.pivot.clone(), n_local);

    // let dx = (local.x - this.pivot.x)*(value-1);
    // let dy = (local.y - this.pivot.y)*(value-1);

    const dx2 = (anchorPx - n_local.x) * (value - 1);
    const dy2 = (anchorPy - n_local.y) * (value - 1);

    // if(this.mapData.id===1)
    // console.log("id:",this.mapData.id,"(",dx,dy," | ",dx2,dy2,")",dx2/dx,this.transform.localTransform.a);

    this.x = this.x - dx2;
    this.y = this.y - dy2;

    this.scale.set(this.scale.x * value, this.scale.y * value);

    if (this.boundBox.visible) { this.control.showSeleted(this); }

    this.SaveData();

    // 绘制锁定点
    // if(this.anchorP2)
    // {
    //     this.anchorP2.clear();
    // }
    // else
    // {
    //     this.anchorP2 = new Graphics();
    //     this.addChild(this.anchorP2);
    // }
    // this.anchorP2.beginFill(0x0000ff)
    // this.anchorP2.lineStyle(1,0x00ffff)
    // this.anchorP2.drawCircle(local.x,local.y,5);
    // this.anchorP2.endFill();
  }


  SaveData() {
    this.mapData.matrix = this.transform.localTransform.clone();
    this.mapData.pos = { x: this.x, y: this.y };

    if (!this.mapData.transform) {
      this.mapData.transform = {};
    }
    const t = this.mapData.transform;
    t.a = this.mapData.matrix.a;
    t.b = this.mapData.matrix.b;
    t.c = this.mapData.matrix.c;
    t.d = this.mapData.matrix.d;
    t.tx = this.mapData.matrix.tx;
    t.ty = this.mapData.matrix.ty;
    t.pox = this.x;
    t.poy = this.y;
    t.alpha = this.alpha;
    t.canSelect = this.mapData.canSelect;
    if (this.mapData.id == 0) {
      if (!this.mapData.params) this.mapData.params = { scale: 1, theta: 0, x_ratio: 0.5, y_ratio: 0.5 };
      this.mapData.params.nowScale = this.scale.x;
      this.mapData.params.trueScale = this.sprite.width * this.mapData.matrix.a / this.orgwidth;
      this.mapData.params.orgwidth = this.orgwidth;
      this.control.mapParams = this.mapData.params;
    }

    setTimeout(() => {
      this.mapData.matrix = this.transform.localTransform.clone();
      this.mapData.pos = { x: this.x, y: this.y };


      this.mapData.transform = {
        a: this.mapData.matrix.a,
        b: this.mapData.matrix.b,
        c: this.mapData.matrix.c,
        d: this.mapData.matrix.d,
        tx: this.mapData.matrix.tx,
        ty: this.mapData.matrix.ty,
        pox: this.x,
        poy: this.y,
        anchorx: this.mapData.anchor ? this.mapData.anchor.x : 0,
        anchory: this.mapData.anchor ? this.mapData.anchor.y : 0,
        pointArg: this.mapData.pointArg,
        bgHeight: (this.control.bgSprite && this.control.bgSprite.height) || 0,
        selfWidth: 800,
        alpha: this.alpha,
        canSelect: this.mapData.canSelect,
      };
    }, 500);
  }

  setMove(dx, dy) {
    this.x += dx;
    this.y += dy;
    this.SaveData();
  }

  setAlpha(value) {
    this.alpha = value;
    this.SaveData();
  }

  drawMask() {
    if (!this.mapData.anchor || this.mapData.anchor.x === 0) return;

    var dis_x = this.mapData.anchor.x * this.sprite.width;
    var dis_y = this.mapData.anchor.y * this.sprite.height;

    this.maskg = new Graphics();
    this.maskg.beginFill(0x00ff00, 0.8);

    let polygonList = [];
    if (this.mapData.pointArg.length > 0) {
      if (this.mapData.pointArg[0] instanceof Array || (this.mapData.pointArg[0].x === undefined && this.mapData.pointArg[0][0] !== undefined)) {
        polygonList = this.mapData.pointArg;
      } else {
        polygonList = [this.mapData.pointArg];
      }
    }

    polygonList.forEach(points => {
      if (points.length < 3) return;
      this.maskg.moveTo(points[0].x + dis_x, points[0].y + dis_y);
      for (let i = 0; i < points.length; i++) {
        this.maskg.lineTo(points[i].x + dis_x, points[i].y + dis_y);
      }
      this.maskg.lineTo(points[0].x + dis_x, points[0].y + dis_y);
    });

    this.maskg.endFill();

    this.sprite.addChild(this.maskg);
    this.sprite.mask = this.maskg;


    // setTimeout(()=>{
    //     console.log('现在的transform',dis_x,dis_y,"[[[[",
    //     this.sprite.transform.localTransform.a,
    //     this.sprite.transform.localTransform.b,
    //     this.sprite.transform.localTransform.c,
    //     this.sprite.transform.localTransform.d,
    //     this.sprite.transform.localTransform.tx,
    //     this.sprite.transform.localTransform.ty);
    // },1000)

    // this.pivot.set(400,300);

    // this.x = 400;
    // this.y = 300;


    // let matrix = new Matrix(0.8910065241883679 ,0.4539904997395468 ,-0.4539904997395468, 0.8910065241883679, 359.79454024651693, 22.101842847670923);
    // this.transform.setFromMatrix(matrix);


    return;
    // 0.41392699180905573 0.028944594914574816 -0.02170844618593111 0.3104452438567918 0 0
    // transform 0.29848124495379713 0.28823998774232257 -0.2161799908067419 0.22386093371534785 0 0

    // let matrix = new Matrix(0.29848124495379713, 0.28823998774232257, -0.2161799908067419, 0.22386093371534785, 0,0);
    // this.sprite.transform.setFromMatrix(matrix);

    // this.x = 557*matrix.a + 300*matrix.a;
    // this.y=  -396*matrix.d-300*matrix.a ;

    var dis_x = 0;
    var dis_y = 0;

    this.sprite.anchor.set(0.5);

    // this.sprite.x=-400;
    // this.sprite.y=-300;

    // this.sprite.x=557;
    // this.sprite.y= 396;

    console.log('this.sprite.width  ', this.sprite.x, this.sprite.y);

    console.log('this.width  ', this.width, this.height);


    this.maskg = new Graphics();
    this.maskg.beginFill(0x00ff00, 0.8);
    this.maskg.moveTo(this.mapData.pointArg[0].x + dis_x, this.mapData.pointArg[0].y + dis_y);


    for (let i = 0; i < this.mapData.pointArg.length; i++) {
      this.maskg.lineTo(this.mapData.pointArg[i].x + dis_x, this.mapData.pointArg[i].y + dis_y);
    }
    this.maskg.lineTo(this.mapData.pointArg[0].x + dis_x, this.mapData.pointArg[0].y + dis_y);
    this.maskg.endFill();

    this.sprite.addChild(this.maskg);
    this.sprite.mask = this.maskg;
  }

  onSelected(value) {
    if (this.boundBox) {
      if (value) {
        this.control.onClickItem(this.mapData);
      }

      this.control.showSeleted(this);
      this.boundBox.visible = value;
    }
  }


  drawBoundBox() {
    const rect = new Rectangle();
    if (this.maskg) { this.maskg.getBounds(true, rect); } else { this.sprite.getBounds(true, rect); }
    // console.log(rect);


    const local = this.toLocal(new Point(rect.x, rect.y));

    // console.log(rect.x,rect.y,local.x,local.y);

    // console.log(this.control.mapCavans.transform.localTransform.a,
    //     this.control.mapCavans.transform.localTransform.b,
    //     this.control.mapCavans.transform.localTransform.c,
    //     this.control.mapCavans.transform.localTransform.d,
    //     this.control.mapCavans.transform.localTransform.tx,
    //     this.control.mapCavans.transform.localTransform.ty,);


    this.boundBox = new Graphics();
    this.boundBox.beginFill(0x0000ff, 0);
    this.boundBox.lineStyle(2, 0x00ff00, 0);
    const scaleA = this.control.mapCavans.transform.localTransform.a;
    // this.boundBox.drawRect(rect2.x/scaleA,rect2.y/scaleA,rect2.width/scaleA,rect2.height/scaleA);
    this.boundBox.drawRect(local.x, local.y, rect.width / this.control.mapCavans.transform.localTransform.a, rect.height / this.control.mapCavans.transform.localTransform.a);
    this.boundBox.endFill();
    this.addChild(this.boundBox);

    this.boundBoxRect = {
      x: local.x, y: local.y, width: rect.width / this.control.mapCavans.transform.localTransform.a, height: rect.height / this.control.mapCavans.transform.localTransform.a,
    };


    this.boundBoxPoint = [new Point(local.x, local.y),
    new Point(local.x + this.boundBoxRect.width, local.y),
    new Point(local.x + this.boundBoxRect.width, local.y + this.boundBoxRect.height),
    new Point(local.x, local.y + this.boundBoxRect.height)];
    // let matrix = new Matrix(this.mapData.matrix.a ,
    //     this.mapData.matrix.b,
    //     this.mapData.matrix.c,
    //     this.mapData.matrix.d,
    //     0,
    //     0);

    // this.boundBox.transform.setFromMatrix(matrix);


    this.boundBox.visible = true;

    this.reSetCenter(rect);
  }

  getRectBoundBox() {
    console.log(this.boundBoxRect);
    return this.boundBoxRect;
  }

  reSetCenter(rect) {
    const local = this.toLocal(new Point(rect.x, rect.y));

    const anchorPx = local.x + rect.width / this.control.mapCavans.transform.localTransform.a / 2;
    const anchorPy = local.y + rect.height / this.control.mapCavans.transform.localTransform.a / 2;

    setTimeout(() => {
      if (this.mapData.matrix) {
        this.pivot.set(anchorPx, anchorPy);

        const matrix = new Matrix(
          this.mapData.matrix.a,
          this.mapData.matrix.b,
          this.mapData.matrix.c,
          this.mapData.matrix.d,
          this.mapData.matrix.tx,
          this.mapData.matrix.ty
        );

        this.transform.setFromMatrix(matrix);

        this.x = this.mapData.pos.x;
        this.y = this.mapData.pos.y;
      } else {
        this.pivot.set(anchorPx, anchorPy);


        if (this.mapData.id == 0) {
          // params: {scale: 20.000000000000004, theta: 0, x_ratio: 0.6311018131101814, y_ratio: 0.4988842538354254}
          // scale: 20.000000000000004
          // theta: 0
          // x_ratio: 0.6311018131101814
          // y_ratio: 0.4988842538354254
          const matrix0 = this.transform.localTransform.clone();
          this.mapData.params.nowScale = matrix0.a;
          this.mapData.params.trueScale = this.sprite.width * matrix0.a / this.orgwidth;

          this.mapData.params.orgwidth = this.orgwidth;

          console.log('this.mapData.params.trueScale:', this.mapData.params.trueScale, this.mapData.params.nowScale, this.mapData.params.orgwidth);

          this.control.mapParams = this.mapData.params;
          // this.mapData.params.scale = this.mapData.scale;
          // this.control.mapParams.nowScaleY = this.sprite * this.mapData.matrix.a /this.orgwidth;
          console.log('0000000000', this.transform.localTransform.clone().a, this.mapData.params.scale);
        }

        const cpsacle = this.control.mapParams.scale * (this.orgwidth / this.control.mapParams.orgwidth) / this.mapData.params.scale;

        const matrix = new Matrix(
          this.control.mapParams.nowScale * cpsacle,
          0,
          0,
          this.control.mapParams.nowScale * cpsacle,
          0,
          0
        );
        this.transform.setFromMatrix(matrix);
        this.x = 400;
        this.y = 300;
      }

      if (this.mapData.alpha != null) { this.alpha = this.mapData.alpha; } else { this.alpha = 1; }

      this.anchorP = new Graphics();
      this.anchorP.beginFill(0xFF0000);
      this.anchorP.lineStyle(1, 0x00ff00);
      this.anchorP.drawCircle(anchorPx, anchorPy, 5);
      this.anchorP.endFill();
      this.addChild(this.anchorP);


      this.SaveData();
    }, 10);
  }


  setRotation(value) {
    this.angle = this.angle + value * 4 / this.control.mapCavans.transform.localTransform.a;


    if (this.boundBox.visible) { this.control.showSeleted(this); }
    this.SaveData();
  }


  setRotation2(value) {
    this.angle = value;


    if (this.boundBox.visible) { this.control.showSeleted(this); }
    this.SaveData();
  }
}

export default MapClip;
